import { render, staticRenderFns } from "./DIconLink.vue?vue&type=template&id=76161bc4&scoped=true&"
import script from "./DIconLink.vue?vue&type=script&lang=js&"
export * from "./DIconLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76161bc4",
  null
  
)

export default component.exports